/** Assessment type metadata and option labels for the wellness modal. */

export interface IAssessmentTypeLabel {
  title: string;
  description: string;
}

export const ASSESSMENT_TYPE_LABELS: Record<string, IAssessmentTypeLabel> = {
  DASS21: {
    title: 'DASS-21',
    description: 'A short screening covering depression, anxiety and stress over the past week.',
  },
  GAD7: {
    title: 'GAD-7',
    description: 'A short screening for generalized anxiety, over the past two weeks.',
  },
  PHQ9: {
    title: 'PHQ-9',
    description: 'A short screening for depression, over the past two weeks.',
  },
};

export const ASSESSMENT_OPTION_LABELS: Record<string, string[]> = {
  DASS21: [
    'Did not apply to me at all',
    'Applied to me to some degree, or some of the time',
    'Applied to me to a considerable degree, or a good part of the time',
    'Applied to me very much, or most of the time',
  ],
  GAD7: ['Not at all', 'Several days', 'More than half the days', 'Nearly every day'],
  PHQ9: ['Not at all', 'Several days', 'More than half the days', 'Nearly every day'],
};

export const DEFAULT_TYPE_LABEL: IAssessmentTypeLabel = {
  title: '',
  description: 'A short wellness screening.',
};

export const DEFAULT_OPTION_LABELS: string[] = ['Not at all', 'A little', 'Quite a bit', 'A lot'];

export const getTypeLabel = (type: string): IAssessmentTypeLabel =>
  ASSESSMENT_TYPE_LABELS[type] ?? { ...DEFAULT_TYPE_LABEL, title: type };

export const getOptionLabels = (type: string): string[] =>
  ASSESSMENT_OPTION_LABELS[type] ?? DEFAULT_OPTION_LABELS;
